import { FC } from 'react';

import { CreditCard } from 'lucide-react';

import { Button } from '../../components/ui/Button';

interface Props {
    readonly handleSubmitOrder: () => void;
    readonly isProcessing: boolean;
    readonly disabled?: boolean;
}

export const OrderFinalActions: FC<Props> = ({
    handleSubmitOrder,
    isProcessing,
    disabled = false,
}) => {
    return (
        <div className="space-y-4">
            <Button
                className="h-12 w-full text-lg"
                onClick={handleSubmitOrder}
                disabled={isProcessing || disabled}
            >
                {isProcessing ? (
                    <>
                        <div className="mr-2 h-5 w-5 animate-spin rounded-full border-b-2 border-white" />
                        Обробка замовлення...
                    </>
                ) : (
                    <>
                        <CreditCard className="mr-2 h-5 w-5" />
                        Оформити замовлення
                    </>
                )}
            </Button>
        </div>
    );
};
